export default __webpack_public_path__ + "static/media/customers-logo-strip.680ac7c2.png";